<template>
  <div>
    <InputLabel 
      v-if="hasLabel"
      :prefix="labelPrefix"
      :isRequiredText="isRequiredText"
      :InputTitle="InputTitle"
    />
    <el-select
      v-model="selectedOption"
      :size="size"
      :placeholder="placeholder"
      :disabled="inactive"
      :loading="loading"
      :placement="placement"
      :suffix-icon="suffixIcon"
      class="new-libary-single-selector"
      popperClass="new-library-popper single-selector-popper"
      @change="change"
    >
      <template v-if="prefix" #prefix>
        <img :src="prefix" width="22" />
      </template>
      <template v-if="loading" #empty>
        <div class="single-selector-loading">
          <div class="single-selector-spinner"></div>
          <span>Loading...</span>
        </div>
      </template>
      <el-option
        v-for="(item, idx) in options"
        class="new-libary-single-selector-dropdown"
        :key="idx"
        :label="item.label ? item.label : item[valueField]"
        :value="item[valueField]"
      >
        <template #default>
          <slot name="option-left" :item="item">
            <span style="float: left">{{ item.countryName || item.label }}</span>
          </slot>
          <slot name="option-right" :item="item">
            <span style="float: right">{{ (item.areaCode || '') }}</span>
          </slot>
        </template>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import InputLabel from './InputLabel.vue'
export default {
  emits: ["change", "update:modelValue"],
  props: {
    hasLabel: {
      type: Boolean,
      default: false
    },
    valueField: {
      type: String,
      default: "value",
    },
    labelPrefix: {
      type: String,
      default: null,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffixIcon: {
      type: [String, Object],
      default: undefined,
    },
    isRequiredText: {
      type: String,
      default: null,
    },
    InputTitle: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Default Option"
    },
    modelValue: {
      type: [String, Number],
      default: ""
    },
    inactive: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  components: {
    InputLabel
  },
  computed: {
    selectedOption: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    }
  }
}
</script>
<style scoped>
/* 只在键盘操作时显示 focus outline，鼠标点击时不显示蓝色边框 */
.new-libary-single-selector:focus:not(:focus-visible),
.new-libary-single-selector .el-input__inner:focus:not(:focus-visible) {
  outline: none !important;
  box-shadow: none !important;
}

/* 去除 el-select 被点击时的蓝色边框 */
.new-libary-single-selector:focus,
.new-libary-single-selector .el-input__inner:focus {
  outline: none !important;
  box-shadow: none !important;
}

.single-selector-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
  gap: 10px;
}

.single-selector-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #E5E7EB;
  border-top-color: #004879;
  border-radius: 50%;
  animation: single-selector-spin 0.8s linear infinite;
}

@keyframes single-selector-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>